<template>
  <div class="pageview">
    <!-- 弹框 -->
    <div class="image-container" @touchmove.prevent v-show="showTK">
      <div class="tankuang">
        <img :src="this.tkInfo.thumbnail" alt="" @click="gotoXq(tkInfo.id)" />
        <img
          class="close"
          @click="closeTK"
          src="http://alycommunity.anluoyun.cn/lc-lcxms/2023/9/84367be0-fd8.png"
        />
      </div>
    </div>
    <!-- <div> -->
    <!-- <van-sticky>
      </van-sticky> -->

    <!-- <div class="topBox">
        <div @click="show = true">{{ OrganName }}</div>
        <div style="margin-left:10px;">
          <van-icon name="arrow-down" />
          <img src="../../assets/箭头.png"
            alt="">
        </div>
        <van-popup v-model="show"
          round
          style="color:black;"
          position="bottom">
          <van-cascader v-model="cascaderValue"
            title="请选择所在地区"
            :options="orgonList"
            @close="show = false"
            :field-names="{
              text: 'OName',
              value: 'OCode',
              children: 'Children',
            }"
            @finish="onFinish" />
        </van-popup>
      </div> -->
    <!-- </div> -->
    <!-- <van-nav-bar title="便民服务" fixed /> -->
    <div class="bgcolor"></div>
    <!-- banner切换 -->
    <van-swipe
      class="homebanner"
      :autoplay="3000"
      indicator-color="white"
      v-if="bannerImgs.length > 0"
    >
      <van-swipe-item
        v-for="banner in bannerImgs"
        :key="banner"
        @click="gotoXq1(banner.id)"
      >
        <div class="Title van-ellipsis">{{ banner.title }}</div>
        <img :src="banner.thumbnail" style="height: 172px" />
      </van-swipe-item>
    </van-swipe>
    <van-swipe
      class="homebanner"
      :autoplay="3000"
      indicator-color="white"
      v-else
    >
      <van-swipe-item v-for="banner in bannerImgs2" :key="banner">
        <img :src="banner" style="height: 172px" />
      </van-swipe-item>
    </van-swipe>
    <div style="margin: 10px auto 0; border-radius: 5px; width: 95%">
      <div style="border-radius: 5px; background: #ffff">
        <!-- <h3 class="grouptitle">便民服务</h3> -->
        <van-grid
          class="wktype"
          :border="false"
          :square="false"
          :column-num="4"
          :gutter="14"
        >
          <template>
            <van-grid-item icon="photo-o" @click="gotoUrl('/fivestar')">
              <van-image
                class="iconimg"
                :src="require('../../assets/五星党建.png')"
              ></van-image>
              <span class="wktext">五星党建</span>
            </van-grid-item>
          </template>
          <van-grid-item icon="photo-o" @click="gotoUrl('/work')">
            <van-image
              class="iconimg"
              :src="require('../../assets/网上办事.png')"
            ></van-image>
            <span class="wktext">政务服务</span>
          </van-grid-item>

          <van-grid-item icon="photo-o" @click="gotoUrl('/article')">
            <van-image
              class="iconimg"
              :src="require('../../assets/zixun.png')"
            ></van-image>
            <span class="wktext">活动通告</span>
          </van-grid-item>
          <!-- <van-grid-item icon="photo-o"
            @click="gotoUrl('/volunteerAct')">
            <van-image class="iconimg"
              :src="require('../../assets/志愿者活动.png')"></van-image>
            <span class="wktext">志愿者活动</span>
          </van-grid-item> -->
          <!-- <van-grid-item icon="photo-o"
            @click="gotoUrl('/partymember')">
            <van-image class="iconimg"
              :src="require('../../assets/智慧党建.png')"></van-image>
            <span class="wktext">智慧党建</span>
          </van-grid-item> -->
          <!-- <template v-else>
        
      </template> -->
          <van-grid-item icon="photo-o" @click="gotoUrl('/scenery')">
            <van-image
              class="iconimg"
              src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/b48e.png"
            ></van-image>
            <span class="wktext">活动风采</span>
          </van-grid-item>
          <van-grid-item icon="photo-o" @click="gotoUrl('/activity')">
            <van-image
              class="iconimg"
              src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/5284.png"
            ></van-image>
            <span class="wktext">工作动态</span>
          </van-grid-item>
          <!-- <template>
        <van-grid-item icon="photo-o"
          @click="gotoUrl('/village')">
          <van-image class="iconimg"
            :src="require('../../assets/shijianyinhang.png')"></van-image>
          <span class="wktext">我的社区(村)</span>
        </van-grid-item>
      </template> -->
          <!-- <template>
            <van-grid-item icon="photo-o"
              @click="gotoUrl('/ylOrder')">
              <van-image class="iconimg"
                :src="require('../../assets/医康养护.png')"></van-image>
              <span class="wktext">医康养护</span>
            </van-grid-item>
          </template> -->
          <van-grid-item icon="photo-o" @click="gotoUrl('/neighbor')">
            <van-image
              class="iconimg"
              :src="require('../../assets/邻里中心.png')"
            ></van-image>
            <span class="wktext">邻里中心</span>
          </van-grid-item>
          <van-grid-item icon="photo-o" @click="gotoUrl('/home')">
            <van-image
              class="iconimg"
              :src="require('../../assets/医康养护.png')"
            ></van-image>
            <span class="wktext">助商助企</span>
          </van-grid-item>
          <van-grid-item icon="photo-o" @click="gotoUrl('/submissions')">
            <van-image
              class="iconimg"
              src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/f4ce.png"
            ></van-image>
            <span class="wktext">居民来稿</span>
          </van-grid-item>
          <!-- <van-grid-item icon="photo-o"
            @click="gotoUrl('/list')">
            <van-image class="iconimg"
              :src="require('../../assets/jiuye.png')"></van-image>
            <span class="wktext">求职招聘</span>
          </van-grid-item> -->

          <!-- <template>
            <van-grid-item icon="photo-o"
              @click="gotoUrl('/register')">
              <van-image class="iconimg"
                :src="require('../../assets/yiqing.png')"></van-image>
              <span class="wktext">疫情防控</span>
            </van-grid-item>
          </template> -->
          <!-- <template>
        <van-grid-item icon="photo-o"
          @click="gotoUrl('/list')">
          <van-image class="iconimg"
            :src="require('../../assets/qiuzhizhaopin.png')"></van-image>
          <span class="wktext">求职招聘</span>
        </van-grid-item>
      </template> -->

          <!-- <van-grid-item icon="photo-o" @click="gotoUrl('/hotel')">
            <van-image
              class="iconimg"
              :src="require('../../assets/民宿旅游.png')"
            ></van-image>
            <span class="wktext">民宿旅游</span>
          </van-grid-item>
          <van-grid-item icon="photo-o" @click="gotoUrl('/notice')">
            <van-image
              class="iconimg"
              :src="require('../../assets/民宿活动.png')"
            ></van-image>
            <span class="wktext">民宿活动</span>
          </van-grid-item> -->
          <!-- <van-grid-item icon="photo-o" @click="gotominiProgramJF(mumberXq)">
            <van-image
              class="iconimg"
              :src="require('../../assets/积分商城.png')"
            ></van-image>
            <span class="wktext">积分商城</span>
          </van-grid-item> -->
          <!-- <van-grid-item icon="photo-o" @click="gotominiProgramTree(mumberXq)">
            <van-image class="iconimg" :src="require('../../assets/积分商城.png')"></van-image>
            <span class="wktext">认领一颗树</span>
          </van-grid-item> -->
        </van-grid>
      </div>
    </div>

    <!-- <div>
      <router-link to="/register">
        <img style="width:90%;margin:8px 5%"
          src="../../assets/dengji.png"
          alt="">
      </router-link>
    </div> -->
    <!-- <br class="brakline" /> -->
    <!-- <div style="width: 95%; margin: 15px auto">
      <div class="essay" style="margin: 0; width: 100%; padding: 0">
        <div
          class="essayContent"
          style="
            padding: 0;
            width: 100%;
            box-shadow: 0px 0px 4px #e7e1e1;
            border-radius: 11px;
          "
          v-html="appInfo.WorkTime"
        ></div>
      </div>
    </div> -->
    <!-- <div style="border-left: 7px solid #eee;border-right: 7px solid #eee;border-bottom: 7px solid #eee;border-top: 1px solid #eee;">
      <h3 class="grouptitle">工作时间</h3>
      <div class="information">
        <div class="center"
          style="border:0px;line-height: 10px;padding: 4px 15px;">
          <div v-html="appInfo.WorkTime"></div>
        </div>
      </div>
    </div> -->
    <!-- 五星支部创建 -->
    <!-- <div style="background:#fff;margin:0 auto 10px;width:95%;border-radius:5px;">
      <div style="padding-top:15px;display: flex;align-items: center;">
        <img src="../../assets/五星.png"
          alt=""
          width="16px">
        <div class="grouptitle">五星支部创建</div>
      </div>
      <div class="information">
        <div class="center"
          v-for="item in partyNoticeList"
          :key="item.index">
          <div @click="gotoUrl('/fivestar/wuXingXq/' + item.AId)">
            <div class="Content"
              style="border-bottom: 1px solid rgb(245 243 243);">
              <div class="ContentB">
                <div class="centerTitle van-ellipsis"
                  style="font-size:16px">{{ item.Title }}</div>
                <span class="centertime van-multi-ellipsis--l2"
                  style="margin:5px 0px;font-size: 13px;color: #666666;">{{ item.Outline }}</span>
                <span class="centertime"
                  style="color: #999999;">{{ item.StartTime | timeFilter}} </span>
              </div>
              <div style="display: inline-block;width: 33%;"
                class="ContentA"
                ref="getHeight">
                <img v-if="item.AImgUrl"
                  :src="item.AImgUrl"
                  alt="" />
              </div>
            </div>
          </div>
        </div>
        <van-empty description="暂无信息"
          v-if="!partyNoticeList.length" />
      </div>
    </div> -->
    <div
      style="
        background: #fff;
        margin: 0 auto 10px;
        width: 95%;
        border-radius: 5px;
      "
    >
      <div style="display: flex; align-items: center; margin-bottom: 8px">
        <img src="../../assets/五星.png" alt="" width="16px" />
        <div class="grouptitle">常用功能</div>
      </div>
      <div style="margin: 2px auto 0; border-radius: 5px; width: 95%">
        <div style="border-radius: 5px; background: #ffff">
          <van-grid
            class="wktype normal"
            :border="false"
            :square="false"
            :column-num="3"
            :gutter="16"
          >
            <van-grid-item @click="gotoUrl2" style="">
              <van-image
                class="iconimg"
                src="https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/fdd9.png"
              ></van-image>
              <span class="wktext">人资圈</span>
            </van-grid-item>
            <van-grid-item @click="gotoUrl3">
              <van-image
                class="iconimg"
                src="https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/01bf.png"
              ></van-image>
              <span class="wktext">物业报修</span>
            </van-grid-item>
            <van-grid-item
              @click="gotoUrl('/guanghe/evaluating' + cascaderValue)"
            >
              <van-image
                class="iconimg"
                src="https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/a096.png"
              ></van-image>
              <span class="wktext">闲置资产出租</span>
            </van-grid-item>
          </van-grid>
        </div>
      </div>
      <!-- <div
        style="display: flex; justify-content: space-around; margin-top: 10px"
      >
        <div class="CYBox" @click="gotoUrl2">
          <img
            src="https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/fdd9.png"
            alt=""
          />
          <div>人资圈</div>
        </div>
        <div class="CYBox" @click="gotoUrl3">
          <img
            src="https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/01bf.png"
            alt=""
          />
          <div>物业报修</div>
        </div> -->

      <!-- <div class="CYBox" @click="staffLogin">
          <img
            src="https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/38b7.png"
            alt=""
          />
          <div>打卡审批</div>
        </div> -->
      <!-- <div
          class="CYBox"
          @click="gotoUrl('/guanghe/evaluating' + cascaderValue)"
        >
          <img
            src="https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/a096.png"
            alt=""
          />
          <div>闲置资产出租</div>
        </div>
      </div> -->
      <div style="padding-top: 12px; display: flex; align-items: center">
        <img src="../../assets/五星.png" alt="" width="16px" />
        <div class="grouptitle">便民资讯</div>
      </div>
      <div
        class="information"
        style="
          box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.02);
          border-radius: 16rpx;
        "
      >
        <van-list
          :loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="30"
          :immediate-check="false"
          @load="onLoad"
        >
          <div
            class="center"
            style="padding: 0px 8px"
            v-for="item in commNoticeList"
            :key="item.index"
          >
            <div @click="gotoUrl1('/trealinfo/detail/' + item.RIId)">
              <div
                class="Content"
                style="
                  border-bottom: 1px solid rgb(245 243 243);
                  position: relative;
                  padding: 10px 0 0px;
                "
              >
                <div class="ContentB">
                  <div
                    class="centerTitle van-multi-ellipsis--l2"
                    style="font-size: 14px"
                  >
                    {{ item.Title }}
                  </div>
                  <!-- <div
                    class="centertime van-multi-ellipsis--l2"
                    style="margin: 5px 0px; font-size: 13px; color: #666666"
                  >
                    {{ item.Summary }}
                  </div> -->
                  <div
                    class="centertime"
                    style="color: #999999; bottom: 5px; position: absolute"
                  >
                    <span>{{ item.IssTime }}</span>
                    <!-- <span style="padding-left: 10px">
                      阅读 {{ item.ReadNum }}</span
                    > -->
                  </div>
                </div>
                <div
                  style="display: inline-block; width: 33%"
                  class="ContentA"
                  ref="getHeight"
                >
                  <img
                    v-if="item.Thematic"
                    :src="item.Thematic"
                    alt=""
                    style="height: 70px; object-fit: cover; display: block"
                  />
                  <img
                    v-else
                    src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
                    alt=""
                    style="height: 70px; object-fit: cover; display: block"
                  />
                </div>
              </div>
            </div>
          </div>
          <van-button v-if="showBtn" @click="backTop" class="backTop"
            ><img
              src="https://dximg.dexian.ren/lczhsq/top.png"
              style="width: 13px; vertical-align: middle"
              alt=""
          /></van-button>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config/index";
import {
  appletList,
  WePBGetRealInfoPage,
  WeGetMyActivityPage,
  WeMyMemberInfo,
} from "@/api/RealInfo";
import { WeGetAppletInfo } from "@/api/index";
import wx from "weixin-js-sdk";
import {
  setOpenId,
  getOpenId,
  setNickName,
  getNickName,
  getToken,
  getaccToken,
  getstaffToken,
  setIsWorkMan,
} from "@/utils/auth";
import { WeGetOrganTree } from "@/api/Organ";
import { WxIsMember } from "@/api/yeguang";
export default {
  // computed: {
  //   ...mapGetters([
  //     'openId',
  //   ])
  // },
  components: {
    // Tabbar,
    // TipsMiniProject,
  },
  data() {
    return {
      showBtn: false,
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      showTK: false,
      appInfo: {},
      bannerImgs: [,],
      bannerImgs2: [
        "http://alycommunity.anluoyun.cn/sx-jgz/2023/6/92a9b0fc-1b5.jpg",
        "https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/1dcf.png",
      ],
      tkInfo: {},
      active: 0,
      partyNoticeList: [],
      commNoticeList: [],
      area: "",
      show: false,
      cascaderValue: "",
      orgonList: [],
      OrganName: "",
      oCode: "",
      OrgCode: "",
      mumberXq: {
        TotalIntegral: 0,
      },
      listfrom: {
        page: 1,
        limit: 10,
        pAKind: 1,
      },
    };
  },
  filters: {
    timeFilter(value) {
      if (value != undefined) {
        let date = new Date(value);

        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, "0");
        let day = date.getDate().toString().padStart(2, "0");
        let hours = date.getHours().toString().padStart(2, "0");
        let minutes = date.getMinutes().toString().padStart(2, "0");
        let seconds = date.getSeconds().toString().padStart(2, "0");

        // 构造新的日期字符串
        let formattedDate =
          year +
          "年" +
          month +
          "月" +
          day +
          "日 " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds;
        return formattedDate;
      }
    },
  },
  created() {
    this.getOrgonTree();
    // this.getAppInfo();
    // 获取并保存openid
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    // 获取并保存nickName
    if (this.$route.query["nickName"]) {
      setNickName(this.$route.query["nickName"]);
    }
    // isWorkMan
    if (this.$route.query["isWorkMan"]) {
      setIsWorkMan(this.$route.query["isWorkMan"]);
    }
    console.log(getNickName());
    this.area = config.area;
    // 获取活动通知
    this.getCommNoticeList();
    this.MemberInfo();
    this.getRealInfoPage();
    this.getRealInfoPage2();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.showBtnF, true);
  },
  methods: {
    //获得页面向左、向上卷动的距离
    getScroll() {
      return {
        top:
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0,
      };
    },
    backTop() {
      // 开个定时器返回顶部时缓慢优雅一些，是 document.body.scrollTop = 0 的升级版
      const timer = setInterval(() => {
        // 页面顶部卷去高度
        let scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        console.log(scrollTop, "scrollTop");
        // 高度控速 = 页面顶部卷去高度正值 / n ===> n 越大，返回越慢
        let ispeed = Math.floor(-scrollTop / 5);
        console.log(scrollTop, "scrollTop");
        console.log(ispeed, "ispeed");
        // 页面顶部卷去高度 + 高度控速 ===> 和不为零，定时器一直开启（不明白的同志可以尝试同时打印 scrollTop 和 ispeed）
        document.body.scrollTop = scrollTop + ispeed;
        document.documentElement.scrollTop = scrollTop + ispeed;
        // 页面顶部卷去高度 + 高度控速 ===> 和为零返回顶部，清除定时器
        if (scrollTop === 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    handleScroll() {
      const scrollTop = this.getScroll().top;
      this.scrollTop = scrollTop;
    },
    showBtnF() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 100) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },
    // 获取弹框广告
    async getRealInfoPage() {
      const res = await appletList({ type: 1 });
      if (res.data.data) {
        this.tkInfo = res.data.data;
        if (res.data.data) {
          this.showTK = true;
        }
        console.log(this.tkInfo, "tkInfo");
      }
    },
    // 获取轮播广告
    async getRealInfoPage2() {
      const res = await appletList({ type: 2 });
      if (res.data.data) {
        this.bannerImgs = res.data.data;
      }
    },
    closeTK() {
      this.showTK = false;
    },
    gotoXq(id) {
      console.log(id);
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../detail/detail?id=" + id,
        });
        // window.wx.miniProgram.navigateTo({
        // url: `../public/gotoJF?path=/hotels/hotelsXq/19900ac4-5dbc-4f54-a521-042925b1f847/${this.mumberXq.totalIntegral}`,
        // });
      } else {
        this.$router.push("../activity/detail.vue");
        // alert("请在小程序中打开");
      }
    },
    gotoXq1(id) {
      console.log(id);
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../detail/detail?id=" + id,
        });
        // window.wx.miniProgram.navigateTo({
        //   url: `../public/gotoJF?path=/hotels/hotelsXq/19900ac4-5dbc-4f54-a521-042925b1f847/${this.mumberXq.totalIntegral}`,
        // });
      } else {
        this.$router.push("../activity/detail.vue");
        // alert("请在小程序中打开");
      }
    },
    // 获取会员详情
    getMyMemberInfo() {
      WeMyMemberInfo({ OpenID: getOpenId() }).then((res) => {
        // console.log(res, '会员详情')
        // this.Name = res.data.data.Name;
        // this.Mobile = res.data.data.Mobile;
        this.cascaderValue = res.data.data.OrgCode;
        // this.getNeInfo(this.cascaderValue);
      });
    },
    // 获取会员详情
    MemberInfo() {
      WxIsMember({ OpenID: getOpenId() }).then((res) => {
        if (res.data.code == "0") {
          // console.log(res.data.data)
          this.mumberXq = res.data.data;
        }
        console.log(this.mumberXq);
      });
    },
    gotoUrlIntrgral() {
      var url =
        "https://mall.anluoyun.cn/#/?integral=" +
        this.mumberXq.integral +
        "&platformId=" +
        config.platformId +
        "&url=" +
        config.hostUrl +
        "&openId=" +
        getOpenId() +
        "&storeId=null";
      window.open(url, "_blank");
      // window.location.href = url
    },
    // 组织机构
    getOrgonTree() {
      WeGetOrganTree().then((res) => {
        this.orgonList = res.data.data;
        this.OrganName = res.data.data[0].OName;
        // this.oCode = res.data.data[0].OName;
        this.OrgCode = res.data.data[0].Children[0].OCode;
        let Code = this.getAllIds(this.orgonList);
        Code.forEach((i) => {
          if (this.cascaderValue == i.OCode) {
            this.OrganName = i.OName;
          }
        });
      });
    },
    // 循环遍历树形结果
    getAllIds(tree) {
      let result = [];
      if (!Array.isArray(tree)) {
        return result;
      }
      tree.forEach((node) => {
        result.push({ OCode: node.OCode, OName: node.OName });
        if (Array.isArray(node.Children)) {
          // result.push(...getAllIds(node.children));
          result = result.concat(this.getAllIds(node.Children));
        }
      });
      return result;
    },
    // 社区搜索
    onFinish: function (val) {
      this.show = false;
      console.log(val);
      // this.fieldValue = val.selectedOptions
      //   .map((option) => option.OName)
      //   .join("/");
      this.fieldValue = val.selectedOptions[val.tabIndex].OName;
      this.OrganName = this.fieldValue;
      this.OCode = val.value;
    },
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    //跳转到公共页面
    gotoUrl1(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // window.wx.miniProgram.redirectTo({
        window.wx.miniProgram.navigateTo({
          url: "../public/gotoZX?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    //跳转到公共页面
    gotoUrl2(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../message/index",
        });
      } else {
        // this.$router.push(path);
        alert("请在小程序中打开");
      }
    },
    gotoUrl3() {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../repairs/repairs",
        });
      } else {
        // this.$router.push(path);
        alert("请在小程序中打开");
      }
    },

    // 员工登录
    staffLogin() {
      if (getstaffToken() == undefined) {
        let path = "/list/staffLogin";
        if (window.__wxjs_environment === "miniprogram") {
          window.wx.miniProgram.navigateTo({
            url: "../public/goto?path=" + path,
          });
        } else {
          // this.$router.push(path);
          alert("请在小程序中打开");
        }
      } else {
        var userId = JSON.parse(getstaffToken()).userId;
        var companyName = JSON.parse(getstaffToken()).companyName;
        var companyId = JSON.parse(getstaffToken()).companyId;
        var userName = JSON.parse(getstaffToken()).userName;
        var platformId = config.platformId1;
        let href = `https://workflow.anluoyun.cn/sign!userId#${userId}-companyName#${companyName}-companyId#${companyId}-platformId#${platformId}-nickName#${userName}`;
        console.log(href, "地址地址");
        // 跳转到 另一个项目
        if (window.__wxjs_environment === "miniprogram") {
          window.wx.miniProgram.navigateTo({
            url: "../public/gotoNew?path=" + href,
          });
        } else {
          alert("请在小程序中打开");
          // window.location.href =
          //   "https://workflow.anluoyun.cn/sign?userId=" +
          //   JSON.parse(getstaffToken()).userId +
          //   "&companyName=" +
          //   JSON.parse(getstaffToken()).companyName +
          //   "&companyId=" +
          //   JSON.parse(getstaffToken()).companyId +
          //   "&platformId=" +
          //   config.platformId1 +
          //   "&nickName=" +
          //   JSON.parse(getstaffToken()).userName;
        }
      }
    },
    //小程序跳转到小程序
    gotominiProgramJF(item) {
      console.log(item.TotalIntegral);
      // return;
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url:
            "../public/JFshop?integral=" +
            item.integral +
            "&platformId=" +
            config.platformId +
            "&url=" +
            config.hostUrl +
            "&storeId=null",
        });
      } else {
        alert("请在小程序中打开");
      }
    },
    //认领一颗树 小程序跳转到小程序
    gotominiProgramTree(item) {
      // return;
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../tree/home/index",
        });
      } else {
        alert("请在小程序中打开");
      }
    },
    //小程序跳转到小程序
    gotominiProgram(name) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/openminip?name=" + name,
        });
      } else {
        alert("请在小程序中打开");
      }
    },
    onLoad() {
      this.listfrom.page = this.listfrom.page + 1;
      this.loading = true;
      this.getCommNoticeList();
    },
    // 获取活动通知
    getCommNoticeList() {
      WePBGetRealInfoPage(this.listfrom).then((res) => {
        this.loading = false;

        if (res.data.code == 0) {
          let rows = res.data.data; //请求返回当页的列表
          // 加载状态结束

          if (rows == null || rows.length === 0) {
            // 加载结束
            console.log("结束");
            this.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          this.commNoticeList = this.commNoticeList.concat(rows);
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.commNoticeList.length >= res.data.count) {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      });
    },
    // 通知消息 五星支部创建
    getNoticeList(row) {
      WeGetMyActivityPage({
        taskClassification: row,
        page: 1,
        limit: 1,
        openid: getOpenId(),
      }).then((res) => {
        if (res.data.code == "0") {
          this.partyNoticeList.push(res.data.data[0]);
          for (var i = 0; i < this.NoticeList.length; i++) {
            var item = this.NoticeList[i].IssTime;
            item = this.dataFormat(item);
            this.partyNoticeList[i].IssTime = item;
          }
        }
      });
    },
    // 时间格式化
    dataFormat(value) {
      var year = value.substr(0, 4);
      var month = value.substr(5, 2);
      var day = value.substr(8, 2);
      var hour = value.substr(11, 2);
      var min = value.substr(14, 2);
      var second = value.substr(17, 2);
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second
      );
    },
    // 小程序展示数据
    getAppInfo() {
      WeGetAppletInfo().then((res) => {
        var list = res.data;
        if (list.code == 0) {
          var imgs = [];
          imgs[0] = list.data.SysPic1;
          imgs[1] = list.data.SysPic2;
          imgs[2] = list.data.SysPic3;
          this.bannerImgs = imgs;
          this.appInfo = list.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.topBox {
  background-color: #f63e3b;
  padding: 10px 10px 0 10px;
  color: white;
  display: flex;
  line-height: 17px;
}
.ContentB {
  display: inline-block;
  width: 59% !important;
  margin-right: 6%;
  margin-left: 0% !important;
}

.bgcolor {
  position: absolute;
  background: linear-gradient(#f63e3b, #fff);
  /* background: #f63e3b; */
  height: 150px;
  width: 100%;
  top: 0;
}

.pageview {
  min-height: 100%;
  /* background: #fff; */
}

.homebanner {
  width: 95%;
  margin: auto;
  margin-top: 5px;
}

.homebanner img {
  width: 100%;
  vertical-align: top;
  border-radius: 5px;
  object-fit: cover;
}

.wktime {
  padding: 0 20px;
}

.wktype {
  padding: 0 5px 0px;
  margin-bottom: 12px;
}

.orginview .iconimg {
  width: 62%;
}

.orginview .linktext {
  font-size: 14px;
  margin-top: 10px;
}

.wktype .iconimg {
  width: 80%;
}

.wktype .wktext {
  margin-top: 8px;
  font-size: 0.75rem;
}

.wktype /deep/ .van-grid-item__content {
  padding: 0 8px;
}

.grouptitle {
  text-indent: 5px;
  font-size: 17px;
  color: #231815;
  font-weight: 700;
}

.brakline {
  height: 5px;
  width: 100%;
  background: #eee;
  display: block;
  content: "";
}

.van-ellipsis--l2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.fuwenben p {
  margin: 0 !important;
}

.normal {
  padding: 0;
  margin-bottom: 0;
}

.normal /deep/ .van-grid-item__content {
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  font-family: PingFang SC;
  font-weight: normal;
  font-size: 12px;
  color: #666666;
  padding: 12px 6px;
  /* height: 100px !important; */
}

.normal /deep/ .iconimg {
  width: 55%;
}
.CYBox {
  /* width: 48%; */
  background: #ffffff;
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  font-family: PingFang SC;
  font-weight: normal;
  font-size: 12px;
  color: #666666;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 15px 24px 19px;
}

.CYBox img {
  width: 40px;
  height: 40px;
  margin-bottom: 13px;
}

.tankuang {
  position: absolute;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 100px;
  width: 100%;
}

.tankuang img:first-child {
  /* width: 86%; */
  width: 300px;
  height: 344px;
  border-radius: 8px;
  object-fit: cover;
}

.image-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
}

.close {
  width: 30px;
  height: 30px;
  margin-top: 15px;
}
.backTop {
  position: fixed;
  bottom: 40px;
  right: 17px;
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.68);
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.06);
  border-radius: 50%;
}

.Title {
  width: 96.4%;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 5px 5px 0 0;
}
</style>
